import React, { useEffect } from 'react';
import styled from 'styled-components';

const ToastContainer = styled.div`
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${props => {
    if (props.type === 'success') return '#57B2A6'; // Green color used for POIs with no type
    if (props.type === 'error') return '#dc3545';   // Red color used for custom activities
    return '#F2C143';                               // Restaurant color for info/default
  }};
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease;
  z-index: 2000;
  text-align: center;
  min-width: 200px;
  max-width: 80%;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
`;

const ToastLink = styled.a`
  color: white;
  text-decoration: underline;
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    color: #e6e6e6;
  }
`;

const Toast = ({ message, onClose, duration = 3000, type = 'info', link }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <ToastContainer show={!!message} type={type}>
      {message}
      {link && (
        <ToastLink href={link.url} target="_blank" rel="noopener noreferrer">
          {link.text}
        </ToastLink>
      )}
    </ToastContainer>
  );
};

export default Toast;
